
$(document).ready(function() {


$(".accordion .header4").click(function () {
            var isActive = $(this).hasClass('active_bg');
            var getParent = $(this).parents('.questions_answer');

            if (isActive) {
               getParent.find('.content').slideUp();
               $(this).removeClass('active_bg');
            } else {
               getParent.find('.content').slideUp();
               $(this).next(".content").slideDown();
               $(".accordion .header4").removeClass('active_bg');
               $(this).addClass('active_bg');
            }
         });

  
});


// ---- new js sanskar work  Start

$(document).on('change', ".prod_card_variant_sec .select__select.new_variant_type", function() {
  let selectedValue = $(this).find('option:selected').val(); 
  let priceValue = $(this).find('option:selected').attr('data-price'); 
  let compareValue = $(this).find('option:selected').attr('compare-price'); 
  let getsale = $(this).find('option:selected').attr('sale-text'); 
  console.log(priceValue);
  $(this).closest('.prod_card_variant_sec').find('.product-variant-id').val(selectedValue);
  $(this).closest('.prod_card_variant_sec').find('s.price-item.price-item--regular .transcy-money').empty().append(compareValue);
  $(this).closest('.prod_card_variant_sec').find('span.price-item.price-item--sale.price-item--last .transcy-money').empty().append(priceValue);
  $(this).closest('.prod_card_variant_sec').find('span.badge.price__badge-sale span:last-child').empty().append(getsale);
});


// ---- new js sanskar work  end